export { default } from './ParsedLabel'
export * from './ParsedLabel'
